import React from "react";
import StyledCheckbox from "../StyledCheckbox";
import { useTranslation } from "../../../i18n/TranslationProvider";
import { translateOr, translateTrigger, translateSymptom } from "../../../i18n/translateData";
import './FactorSelector.scss'

const FactorSelector = ({
    factors,
    colors,
    selectedCategory,
    selectedFactors,
    onCategoryClick,
    onFactorSelect,
    isChecked,
    other,
    onOtherChange,
    onAddOther,
    onSubmit
}) => {
    const { t } = useTranslation();

    // Display only — the English category/factor values are what get passed to handlers
    const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
    const categoryLabel = (category) =>
        translateOr(t, `dashboard.triggerCategory.${capitalize(category)}`, null) ??
        translateOr(t, `dashboard.symptomCategory.${capitalize(category)}`, category);
    const factorLabel = (factor, category) => {
        const trigger = translateTrigger(t, factor);
        return trigger !== factor ? trigger : translateSymptom(t, factor, category);
    };
    return (
        <div className='factor-selector-container'>
            <div className='select-factors'>
                <h5 className='select-header'>{t("dashboard.factorSelector.selectHeader")}</h5>
                <div className='select-factors-pane'>
                    <div className='category-pane'>
                        {Object.keys(factors).map((category) => (
                            <div
                                key={category}
                                className='category-item'
                                style={{ backgroundColor: colors[category] }}
                                onClick={() => onCategoryClick(category)}
                            >
                                {categoryLabel(category)}
                            </div>
                        ))}
                    </div>
                    <div className='factor-pane'>
                        {selectedCategory && (
                            <div>
                                <h6>{t("dashboard.factorSelector.categoryFactors", { category: categoryLabel(selectedCategory) })} <span>({t("onboarding.choose.chooseAll")})</span></h6>
                                <div className='factors-list'>
                                    {factors[selectedCategory].map((factor) => (
                                        <div key={factor} className="factor-item">
                                            <label className='custom-checkbox-container'>
                                                <input
                                                    type="checkbox"
                                                    value={factor}
                                                    onChange={() => onFactorSelect(factor, selectedCategory)}
                                                />
                                                <StyledCheckbox
                                                    category={selectedCategory}
                                                    colors={colors}
                                                    isChecked={isChecked(factor, selectedCategory)}
                                                />
                                                {factorLabel(factor, selectedCategory)}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                                <div className='other-container'>
                                    <p>{t("onboarding.other")}:</p>
                                    <input
                                        className='other-input-field'
                                        type='text'
                                        value={other}
                                        onChange={onOtherChange}
                                        onKeyDown={onAddOther}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className='selected-factors'>
                <h5 className='selected-header'>{t("dashboard.factorSelector.selectedHeader")}</h5>
                <div className='selection-pane'>
                    {selectedFactors.length > 0 && (
                        <div className='factors-list'>
                            {selectedFactors.map((item) => (
                                <div key={item.factor} className="factor-item">
                                    <label className='custom-checkbox-container'>
                                        <input
                                            type="checkbox"
                                            value={item.factor}
                                            onChange={() => onFactorSelect(item.factor, item.category)}
                                            checked
                                        />
                                        <StyledCheckbox
                                            category={item.category}
                                            colors={colors}
                                            isChecked={isChecked(item.factor, item.category)}
                                        />
                                        {factorLabel(item.factor, item.category)}
                                    </label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default FactorSelector;